import { DOCUMENT } from '@angular/common';
import { Injectable, Inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { LANGUAGE } from '../../../shared/injection-tokens';
import { Language } from '../../../shared/salesforce-types';

@Injectable({
    providedIn: 'root',
})
export class LanguageResolver {
    constructor(@Inject(LANGUAGE) private language: BehaviorSubject<Language>, @Inject(DOCUMENT) private document: Document) {}

    resolve(route: ActivatedRouteSnapshot): Language {
        const language = route.data.language as Language;
        this.language.next(language);
        this.document.documentElement.lang = language === Language.Es ? 'es' : 'en';
        return language;
    }
}
